'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _bind = require('classnames/bind');

var _bind2 = _interopRequireDefault(_bind);

var _List = require('components/List/List');

var _List2 = _interopRequireDefault(_List);

var _RecipientDetailedStatsListHeader = require('components/Statistics/RecipientDetailedStatsList/RecipientDetailedStatsListHeader');

var _RecipientDetailedStatsListHeader2 = _interopRequireDefault(_RecipientDetailedStatsListHeader);

var _RecipientDetailedStatsListItem = require('components/Statistics/RecipientDetailedStatsList/RecipientDetailedStatsListItem');

var _RecipientDetailedStatsListItem2 = _interopRequireDefault(_RecipientDetailedStatsListItem);

var _statistics = require('helpers/statistics');

var _Loader = require('components/Loader/Loader');

var _Loader2 = _interopRequireDefault(_Loader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = require('./RecipientDetailedStatsList.scss');

var RecipientDetailedStatsList = (_temp = _class = function (_PureComponent) {
  (0, _inherits3.default)(RecipientDetailedStatsList, _PureComponent);

  function RecipientDetailedStatsList() {
    (0, _classCallCheck3.default)(this, RecipientDetailedStatsList);
    return (0, _possibleConstructorReturn3.default)(this, (RecipientDetailedStatsList.__proto__ || (0, _getPrototypeOf2.default)(RecipientDetailedStatsList)).apply(this, arguments));
  }

  (0, _createClass3.default)(RecipientDetailedStatsList, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          loading = _props.loading,
          _props$data = _props.data,
          tracks = _props$data.tracks,
          timings = _props$data.timings;


      if (loading) {
        return _react2.default.createElement(_Loader2.default, { show: loading, alignCenter: true });
      }

      return _react2.default.createElement(
        _List2.default,
        { className: (0, _bind2.default)(styles.list, className) },
        _react2.default.createElement(_RecipientDetailedStatsListHeader2.default, null),
        timings.map(function (stat) {
          return _react2.default.createElement(_RecipientDetailedStatsListItem2.default, {
            key: stat.uuid,
            data: stat,
            track: tracks[stat.trackId]
          });
        })
      );
    }
  }]);
  return RecipientDetailedStatsList;
}(_react.PureComponent), _class.propTypes = {
  className: _propTypes2.default.string,
  data: _propTypes2.default.object,
  loading: _propTypes2.default.bool
}, _class.defaultProps = {
  data: _statistics.defaultDetailedData,
  loading: false
}, _temp);
exports.default = RecipientDetailedStatsList;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Statistics/RecipientDetailedStatsList/RecipientDetailedStatsList.js
// module id = 2116
// module chunks = 1